import { render } from "./vew_nursing_result_modal.vue?vue&type=template&id=673cd282&scoped=true"
import script from "./vew_nursing_result_modal.vue?vue&type=script&lang=js"
export * from "./vew_nursing_result_modal.vue?vue&type=script&lang=js"

import "./vew_nursing_result_modal.vue?vue&type=style&index=0&id=673cd282&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673cd282"]])

export default __exports__